/**
 * BOTTOM NAVIGATION BAR
 * Matches mockup: Home | Road | Check In | Badges | Partners
 * Uses DM Sans, copper active color, emoji icons
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { T } from '../theme';

const tabs = [
  { to: "/home", icon: "🏠", label: "Home" },
  { to: "/trail", icon: "🗺️", label: "Road" },
  { to: "/checkin", icon: "📷", label: "Check In" },
  { to: "/badges", icon: "🏅", label: "Badges" },
  { to: "/partners", icon: "🤝", label: "Partners" },

];

export default function BottomNav({ active }) {
  return (
    <nav style={{
      position: "fixed", bottom: 0, left: 0, right: 0,
      background: "white", borderTop: `1px solid ${T.creamDark}`,
      display: "flex", padding: "8px 0 6px", zIndex: 4000
    }}>
      {tabs.map(t => {
        const isActive = active === t.to;
        return (
          <Link key={t.to} to={t.to} style={{
            flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3,
            textDecoration: "none", padding: "4px 2px",
            opacity: isActive ? 1 : 0.4,
          }}>
            <span style={{ fontSize: 19 }}>{t.icon}</span>
            <span style={{
              fontSize: 9, fontFamily: "'DM Sans', sans-serif", fontWeight: 600,
              color: isActive ? T.copper : T.smoke, letterSpacing: "0.04em"
            }}>{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
